import { render, staticRenderFns } from "./PostalCodeInput.vue?vue&type=template&id=62f903b8&"
import script from "./PostalCodeInput.vue?vue&type=script&lang=js&"
export * from "./PostalCodeInput.vue?vue&type=script&lang=js&"
import style0 from "./PostalCodeInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
